import { connect } from "react-redux";
import React, { useState } from "react";
import { Button } from "reactstrap";
import enhancer from "./enhancer/TermsConditionEnhancer";
import { compose } from "redux";
import navigationAction from "redux/navigation/actions";
import { useEffect } from "react";
import Loader from "components/Loader";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { addTandC, getTandC } from "services/TandCServices";

const { success, error } = navigationAction;

const TermAndCondition = props => {
  const { sidebarTheme } = props;
  const {
    values,
    handleBlur,
    errors,
    touched,
    submitCount,
    token,
    setFieldValue,
    handleSubmit
  } = props;

  const options = [
    { value: "User", label: "User" },
    { value: "Merchant", label: "Merchant" }
  ];
  const activeColor = {
    color: sidebarTheme.activeColor
  };

  const [loading, setLoading] = useState(false);
  const [getData, setGetData] = useState([]);
  useEffect(() => {
    getTermAndConditionHandler();
  }, []);

  const getTermAndConditionHandler = async () => {
    setLoading(true);
    const selectedOption =
      values.TandC_for === "Merchant" ? "Merchant" : "User";
    // debugger;
    await getTandC(token, selectedOption).then(res => {
      // debugger;
      if (res.success) {
        setLoading(false);
        if (res.data.length > 0) {
          setFieldValue(
            "TandC_for",
            res.data.filter(val => val.TandC_for === "User")[0]?.TandC_for
          );
          setFieldValue(
            "TandC_description",
            res.data.filter(val => val.TandC_for === "User")[0]
              ?.TandC_description
          );
        }

        setGetData(res.data);
      } else {
        error(res.message);
        setLoading(false);
      }
    });
  };
  const updateGetData = async () => {
    const selectedOption =
      values.TandC_for === "Merchant" ? "Merchant" : "User";
    await getTandC(token, selectedOption).then(res => {
      if (res.success) setGetData(res.data);
      else {
        error(res.message);
        setLoading(false);
      }
    });
  };
  const TermAndConditionHandler = async e => {
    e.preventDefault();
    handleSubmit();

    setLoading(true);
    await addTandC(token, values).then(res => {
      if (res.success) {
        success(res.message);
        console.log("message", res.data.message);
        setLoading(false);
        setFieldValue("TandC_for", res.data.TandC_for);
        setFieldValue("TandC_description", res.data.TandC_description);
        updateGetData();
      } else {
        console.log({ errorrororor: res.message });
        error(res.message);
        setLoading(false);
      }
    });
  };

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.className ? props.className : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  return (
    <>
      <div className="row">
        <div className="col mb-2">
          <div className="introduction" style={activeColor}>
            Terms and Condition
          </div>
        </div>
      </div>
      <div className="quill-tnc">
        <form>
          <div className="form-group my-3 col-4">
            <Select
              options={options}
              placeholder="Select..."
              name="TandC_for"
              onChange={e => {
                if (e.value === "Merchant") {
                  setFieldValue(
                    "TandC_description",
                    getData.filter(item => item?.TandC_for === "Merchant")[0]
                      ?.TandC_description
                  );
                } else {
                  const data = getData.filter(
                    item => item?.TandC_for === "User"
                  );
                  if (data.length > 0) {
                    const desc = data[0].TandC_description;
                    setFieldValue("TandC_description", desc);
                  } else {
                    setFieldValue("TandC_description", "");
                  }
                }

                setFieldValue("TandC_for", e.value);
              }}
              onBlur={handleBlur}
              value={options.find(x => {
                return x.value === values.TandC_for;
              })}
            />
            <Error field="TandC_for" />
          </div>

          <div className="form-group w-100 col-12 ">
            <label>Description</label>
            <ReactQuill
              name="TandC_description"
              id="TandC_description"
              className="tnc-quill"
              value={values?.TandC_description}
              theme="snow" // Specify the desired Quill theme (e.g., 'snow')
              placeholder="Enter the description here..."
              // onChange={(content) => {
              //   setFieldValue("TandC_description", content);
              // }}
              onChange={(content, delta, source, editor) => {
                if (editor.getLength() <= 1) {
                  setFieldValue("TandC_description", "");
                } else {
                  setFieldValue("TandC_description", content, false);
                }
              }}
              onBlur={(previousRange, source, editor) => {
                setFieldValue("TandC_description", editor.getHTML());
              }}
              modules={TermAndCondition.modules}
              formats={TermAndCondition.formats}
            />
            <Error field="TandC_description" />
          </div>

          <div className="row justify-content-center">
            <div className="col-auto">
              <Button
                onClick={e => TermAndConditionHandler(e)}
                type="submit"
                className="btn btn-info w-100 btn-bordered"
                // disabled={isValid ? false : true}
              >
                Save
              </Button>
            </div>
          </div>
        </form>
      </div>
      {loading ? <Loader /> : ""}
    </>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken
  };
};

export default compose(
  enhancer,
  connect(mapStateToProps, { success, error })
)(TermAndCondition);

TermAndCondition.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote", "link"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" }
    ]
  ],
  clipboard: {
    matchVisual: false
  }
};
TermAndCondition.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link"
];
